export function IsPersianChar(value: string) {
    const regex = /^[\u0600-\u06FF\s]+$/;

    if (!regex.test(value)) return false;

    return true;
}
